import React, {useState} from 'react';
import { Link, NavLink } from "react-router-dom";
import {useDispatch} from "react-redux";
import logo from "../../resources/img/logo6.png";
import ProductBasket from "../Pages/Products/ProductElements/productBasket";

function Header() {

    //const [sessionStorage,setStorage]=useState();
    //const dispatch = useDispatch();

    return (

        <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-100 font-script">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

                {/* LOGO */}
                <Link to="/" className="flex items-center space-x-3">
                    <h1 className="text-2xl font-serif font-semibold text-brand-green">
                        <img className="max-w h-[100px]" src={logo}/>
                    </h1>
                </Link>

                {/* NAV */}
                <nav className="hidden md:flex items-center space-x-8">
                    <Link className="nav-link" to="/">Home</Link>
                    <Link className="nav-link" to="/products">Products</Link>
                    <Link className="nav-link" to="/specialorder">Special Order</Link>
                    <Link className="nav-link" to="/about">About</Link>
                    <Link className="nav-link" to="/contact">Contact</Link>
                </nav>
                <div id="header-actions" className="flex items-center space-x-4">
                    <div className="relative">

                    </div>
                   <ProductBasket/>
                </div>
            </div>
</header>

)
    ;


}

export default Header;